export default {
    "name": "ReportTitlesQuery",
    "kind": "HoudiniQuery",
    "hash": "fa78b1b1791d5b55250819af8e882ef44b236243f86bfc222b6ea05d71990583",

    "raw": `query ReportTitlesQuery($args: DashboardReportArgs) {
  dashboardReports(args: $args) {
    dashboardReportId: id
    name
    title
    ownerId
    id
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "dashboardReports": {
                "type": "DashboardReport",
                "keyRaw": "dashboardReports(args: $args)",

                "selection": {
                    "fields": {
                        "dashboardReportId": {
                            "type": "Int",
                            "keyRaw": "dashboardReportId",
                            "visible": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "visible": true
                        },

                        "title": {
                            "type": "String",
                            "keyRaw": "title",
                            "visible": true
                        },

                        "ownerId": {
                            "type": "Int",
                            "keyRaw": "ownerId",
                            "nullable": true,
                            "visible": true
                        },

                        "id": {
                            "type": "Int",
                            "keyRaw": "id",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "args": "DashboardReportArgs"
        },

        "types": {
            "DashboardReportArgs": {
                "editableByCurrentUser": "Boolean",
                "sharedWithCurrentUser": "Boolean"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=fb7acddce88f4387518a1cdf0944290a0d3dc6fd74f9fd2a2ef5d6b059b8ca95";